/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './home-page.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../app/home-page/home-page.component';
import * as i4 from '../../../app/.providers/auth.service';
import * as i5 from '@angular/router';
import * as i6 from 'angularfire2/database/database';
const styles_HomePageComponent:any[] = [i0.styles];
export const RenderType_HomePageComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_HomePageComponent,data:{}});
function View_HomePageComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'clearfix']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'label',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['Project - ',
          ' (',')'])),(_l()(),i1.ɵted((null as any),['\n\n            ']))],(null as any),
      (_ck,_v) => {
        const currVal_0:any = _v.context.$implicit.name;
        const currVal_1:any = _v.context.$implicit.shortName;
        _ck(_v,3,0,currVal_0,currVal_1);
      });
}
export function View_HomePageComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),14,'div',[['class',
      'container']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          11,'div',[['class','row']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),8,'div',[['class','blog']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h2',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['Existing Projects'])),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          2,(null as any),View_HomePageComponent_1)),i1.ɵdid(802816,(null as any),
          0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,
              'ngForOf']},(null as any)),i1.ɵpid(131072,i2.AsyncPipe,[i1.ChangeDetectorRef]),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i3.HomePageComponent = _v.component;
    const currVal_0:any = i1.ɵunv(_v,10,0,i1.ɵnov(_v,11).transform(_co.projects));
    _ck(_v,10,0,currVal_0);
  },(null as any));
}
export function View_HomePageComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-home-page',
      ([] as any[]),(null as any),(null as any),(null as any),View_HomePageComponent_0,
      RenderType_HomePageComponent)),i1.ɵdid(114688,(null as any),0,i3.HomePageComponent,
      [i4.AuthService,i5.Router,i6.AngularFireDatabase],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const HomePageComponentNgFactory:i1.ComponentFactory<i3.HomePageComponent> = i1.ɵccf('app-home-page',
    i3.HomePageComponent,View_HomePageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovT25lRHJpdmUvRGV2L2ZpcmViYXNlL2FsYWdhdGltZV9ib290c3RyYXAvc3JjL2FwcC9ob21lLXBhZ2UvaG9tZS1wYWdlLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9EOi9PbmVEcml2ZS9EZXYvZmlyZWJhc2UvYWxhZ2F0aW1lX2Jvb3RzdHJhcC9zcmMvYXBwL2hvbWUtcGFnZS9ob21lLXBhZ2UuY29tcG9uZW50LnRzIiwibmc6Ly8vRDovT25lRHJpdmUvRGV2L2ZpcmViYXNlL2FsYWdhdGltZV9ib290c3RyYXAvc3JjL2FwcC9ob21lLXBhZ2UvaG9tZS1wYWdlLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovT25lRHJpdmUvRGV2L2ZpcmViYXNlL2FsYWdhdGltZV9ib290c3RyYXAvc3JjL2FwcC9ob21lLXBhZ2UvaG9tZS1wYWdlLmNvbXBvbmVudC50cy5Ib21lUGFnZUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJjb250YWluZXJcIj5cbiAgICA8ZGl2IGNsYXNzPVwicm93XCI+XG4gICAgICAgIDxkaXYgY2xhc3M9XCJibG9nXCI+XG4gICAgICAgICAgICA8aDI+RXhpc3RpbmcgUHJvamVjdHM8L2gyPlxuICAgICAgICAgICAgPGRpdiAqbmdGb3I9XCJsZXQgcHJvamVjdCBvZiBwcm9qZWN0cyB8IGFzeW5jXCIgY2xhc3M9XCJjbGVhcmZpeFwiPlxuICAgICAgICAgICAgICAgIDxsYWJlbD5Qcm9qZWN0IC0ge3twcm9qZWN0Lm5hbWV9fSAoe3twcm9qZWN0LnNob3J0TmFtZX19KTwvbGFiZWw+XG5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbjwvZGl2PiIsIjxhcHAtaG9tZS1wYWdlPjwvYXBwLWhvbWUtcGFnZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0lZO01BQUE7TUFBK0QsdURBQzNEO1VBQUE7VUFBQSw4QkFBTztVQUFBLFlBQTBEOztRQUExRDtRQUFBO1FBQUE7Ozs7b0JBTHZCO01BQUE7TUFBdUIsMkNBQ25CO1VBQUE7VUFBQSxnQkFBaUIsK0NBQ2I7VUFBQTtVQUFBLDRDQUFrQjtVQUFBLHFCQUNkO1VBQUE7TUFBSSxzREFBc0I7VUFBQSxxQkFDMUI7VUFBQSxrREFBQTtVQUFBO2NBQUEsa0NBQUs7TUFHQywrQ0FDSjtVQUFBLGFBQ0o7O0lBTE87SUFBTCxZQUFLLFNBQUw7Ozs7b0JDSlo7TUFBQTtrQ0FBQSxVQUFBO01BQUE7O1FBQUE7Ozs7In0=



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/$$_gendir/app/home-page/home-page.component.ngfactory.ts